import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAuthUser, IPageCount, IState } from './types';

// --------------------------------------------

export const initialState: IState = {
  token: '',
  paginationModule: {},
  user: null,
};

const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setAuthUser(state, action: PayloadAction<IAuthUser | null>) {
      state.user = action.payload;
    },
    setPageCount(state, action: PayloadAction<IPageCount>) {
      if (!state.paginationModule) {
        state.paginationModule = {};
      }
      state.paginationModule[action.payload.id] = action.payload.count;
    },
  },
});

export default slice.reducer;

export const { setToken, setAuthUser, setPageCount } = slice.actions;
